import React, { useState } from "react";
import { Outlet } from "react-router-dom";

import Navigation from "./nav";
import { styled, useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";
import useResponsive from "../../hooks/useResponsive";
import NotificationContent from "../notification-content";

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;
const NAV_WIDTH = 350;

const Main = styled("div")(({ theme }) => ({
  position: "relative",
  [theme.breakpoints.up("lg")]: {
    // paddingTop: 16,
    // paddingLeft: theme.spacing(2),
    // paddingRight: theme.spacing(2),
  },
}));

export default function DashboardLayout() {
  const isMedium = useResponsive("down", "md", "xs");
  const isDesktop = useResponsive("down", "lg", "xs");

  const theme = useTheme();
  return (
    <Box
      sx={{
        height: "100vh",
        background: theme.palette.lightBlue.light,
        display: "flex",
      }}
    >
      <Box
        sx={{
          background: theme.palette.common.white,
          width: isDesktop ? 0 : NAV_WIDTH,
        }}
      >
        <Navigation />
      </Box>
      <Box
        sx={{
          overflowY: "auto",
          height: "100vh",
          width: "100%",
        }}
      >
        <NotificationContent />
        <Main>
          <Outlet />
        </Main>
      </Box>
    </Box>
  );
}
